"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.EditableImage = void 0;

var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/fill"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _EditableImage = require("./EditableImage.styles");

var _EditableImageController = require("./EditableImageController");

var FillStyles;

(function (FillStyles) {
  FillStyles["Background"] = "#ffffff";
  FillStyles["Cropped"] = "#000000";
  FillStyles["Loading"] = "#eeeeee";
})(FillStyles || (FillStyles = {}));

var CanvasScale;

(function (CanvasScale) {
  CanvasScale[CanvasScale["Maximum"] = 1000] = "Maximum";
  CanvasScale[CanvasScale["Minimum"] = 100] = "Minimum";
})(CanvasScale || (CanvasScale = {}));

var canvasRenderingContext = '2d';
var getClassNames = (0, _react.classNamesFunction)();
var classes = getClassNames(_EditableImage.styles);

var EditableImage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EditableImage, _React$Component);

  var _super = (0, _createSuper2.default)(EditableImage);

  function EditableImage() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, EditableImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.state = {
      scale: 100
    };
    _this._canvasPreview = /*#__PURE__*/React.createRef();
    _this._canvasControls = /*#__PURE__*/React.createRef();
    _this._image = void 0;
    _this._imageHasLoaded = false;
    _this._isDragging = false;
    _this._imageDragOriginX = 0;
    _this._imageDragOriginY = 0;
    _this._canvasWidth = _this.props.resolutionX;
    _this._canvasHeight = _this.props.resolutionY;
    _this.controller = void 0;

    _this.render = function () {
      var scale = _this.state.scale;
      var sliderAriaLabel = _this.props.sliderAriaLabel;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("canvas", {
          className: classes.canvasControls,
          ref: _this._canvasControls,
          width: _this._canvasWidth,
          height: _this._canvasHeight,
          onWheel: _this._onWheel,
          onMouseMove: _this._onMouseMove,
          onMouseDown: _this._onMouseDown,
          onMouseUp: _this._onMouseUp,
          onMouseLeave: _this._onMouseLeave
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("canvas", {
          className: classes.canvasPreview,
          ref: _this._canvasPreview,
          width: _this._canvasWidth,
          height: _this._canvasHeight
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Stack, {
          horizontal: true,
          verticalAlign: "center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            iconName: "CalculatorSubtract"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Stack.Item, {
            grow: true,
            disableShrink: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Slider, {
              ariaLabel: sliderAriaLabel,
              min: CanvasScale.Minimum,
              max: CanvasScale.Maximum,
              showValue: false,
              value: scale,
              onChange: _this._onSliderValueChange
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Icon, {
            iconName: "CalculatorAddition"
          })]
        })]
      });
    };

    _this.componentDidMount = function () {
      _this._renderOverlay();

      _this._redrawPicture();

      _this._instantiateController();

      document.addEventListener('keydown', _this._onKeydown);
    };

    _this.componentWillUnmount = function () {
      document.removeEventListener('keydown', _this._onKeydown);
    };

    _this.componentDidUpdate = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this._instantiateController();

            case 2:
              _this._redrawPicture();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));
    _this.getOutputBlobPromise = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var outputMimeType;
      return _regenerator.default.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              outputMimeType = _this.props.outputMimeType;
              return _context3.abrupt("return", _this.controller ? _this.controller.GetBlobImage(outputMimeType) : new Blob());

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2);
    }));
    _this._instantiateController = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var editableImageDataUri, imageHasChanged, controllerShouldInstantiate, startX, startY;
      return _regenerator.default.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              editableImageDataUri = _this.props.editableImageDataUri;
              imageHasChanged = _this._image && _this._image.src !== editableImageDataUri;
              controllerShouldInstantiate = _this.controller === undefined || imageHasChanged === true;

              if (!controllerShouldInstantiate) {
                _context4.next = 10;
                break;
              }

              _context4.next = 6;
              return _this._loadImage();

            case 6:
              _this._image = _context4.sent;
              startX = 0;
              startY = 0;
              _this.controller = new _EditableImageController.EditableImageController(_this._image, _this._canvasWidth, _this._canvasWidth, startX, startY);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3);
    }));
    _this._loadImage = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var editableImageDataUri;
      return _regenerator.default.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              editableImageDataUri = _this.props.editableImageDataUri;
              return _context5.abrupt("return", new _promise.default(function (resolve, reject) {
                _this._imageHasLoaded = false;
                var image = new Image();
                image.src = editableImageDataUri;

                image.onload = function () {
                  _this._imageHasLoaded = true;
                  resolve(image);
                };

                image.onerror = function (err) {
                  reject(err);
                };
              }));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4);
    }));

    _this._renderOverlay = function () {
      var controlCanvasContext = _this._canvasControls.current && _this._canvasControls.current.getContext(canvasRenderingContext);

      if (controlCanvasContext) {
        _this._drawCroppedCircle(controlCanvasContext);
      }
    };

    _this._onKeydown = function (ev) {
      var translatePxX = _this._image !== undefined ? Math.round(_this._image.width / 100) : 1;
      var translatePxY = _this._image !== undefined ? Math.round(_this._image.height / 100) : 1;

      if (ev.key === 'ArrowUp') {
        _this._translate(0, -translatePxY);
      } else if (ev.key === 'ArrowDown') {
        _this._translate(0, translatePxY);
      } else if (ev.key === 'ArrowLeft') {
        _this._translate(-translatePxX, 0);
      } else if (ev.key === 'ArrowRight') {
        _this._translate(translatePxX, 0);
      } else if (ev.key === '+') {
        _this._scaleUp();
      } else if (ev.key === '-') {
        _this._scaleDown();
      }

      _this._redrawPicture();
    };

    _this._onWheel = function (ev) {
      if (_this.controller === undefined) {
        return;
      }

      var isScrollingUp = ev.deltaY < 0;

      if (isScrollingUp) {
        _this._scaleUp();
      } else {
        _this._scaleDown();
      }

      _this._redrawPicture();
    };

    _this._onMouseMove = function (ev) {
      if (_this._isDragging && _this.controller) {
        _this.controller.SetDragPosition(_this._imageDragOriginX, _this._imageDragOriginY, ev.clientX, ev.clientY);

        _this._redrawPicture();
      }
    };

    _this._onMouseDown = function (ev) {
      if (_this.controller) {
        _this._isDragging = true;
        _this._imageDragOriginX = _this.controller.GetCanvasOutput().offsetX - ev.clientX;
        _this._imageDragOriginY = _this.controller.GetCanvasOutput().offsetY - ev.clientY;
      }
    };

    _this._onMouseUp = function (_ev) {
      _this._isDragging = false;
    };

    _this._onMouseLeave = function (_ev) {
      _this._isDragging = false;
    };

    _this._redrawPicture = function () {
      var canvas = _this._canvasPreview.current;
      var context = canvas && canvas.getContext(canvasRenderingContext);
      var canRenderImage = _this._image !== undefined && _this._imageHasLoaded && _this.controller !== undefined;

      if (!_this.controller || !context || !canvas || !_this._image) {
        return;
      }

      if (canRenderImage) {
        var output = _this.controller.GetCanvasOutput();

        _this._drawImage(context, output, _this._image);

        _this.props.handleCanvasUpdate(_this.getOutputBlobPromise);
      } else {
        _this._drawLoading(context);
      }
    };

    _this._drawImage = function (context, output, image) {
      var offsetX = output.offsetX,
          offsetY = output.offsetY,
          destinationWidth = output.destinationWidth,
          destinationHeight = output.destinationHeight;
      context.globalAlpha = 1;
      context.fillStyle = FillStyles.Background;
      context.fillRect(0, 0, _this._canvasWidth, _this._canvasHeight);
      context.drawImage(image, offsetX, offsetY, destinationWidth, destinationHeight);
    };

    _this._drawCroppedCircle = function (context) {
      context.globalAlpha = 0.5;
      context.fillStyle = FillStyles.Cropped;
      context.fillRect(0, 0, _this._canvasWidth, _this._canvasHeight);
      context.globalAlpha = 1;
      context.globalCompositeOperation = 'destination-out';
      context.beginPath();
      context.arc(_this._canvasWidth / 2, _this._canvasHeight / 2, _this._canvasHeight / 2, 0, Math.PI * 2);
      context.closePath();
      (0, _fill.default)(context).call(context);
      context.globalCompositeOperation = 'source-over';
    };

    _this._drawLoading = function (context) {
      context.globalAlpha = 1;
      context.fillStyle = FillStyles.Loading;
      context.fillRect(0, 0, _this._canvasWidth, _this._canvasHeight);
    };

    _this._onSliderValueChange = function (value) {
      _this._setScale(value);
    };

    _this._scaleUp = function () {
      var scale = _this.state.scale;

      if (scale < CanvasScale.Maximum) {
        var newScale = scale + 5;

        _this._setScale(newScale);
      }
    };

    _this._scaleDown = function () {
      var scale = _this.state.scale;

      if (scale > CanvasScale.Minimum) {
        var newScale = scale - 5;

        _this._setScale(newScale);
      }
    };

    _this._setScale = function (value) {
      if (_this.controller) {
        _this.controller.SetScale(value);
      }

      _this.setState({
        scale: value
      });
    };

    _this._translate = function (translateX, translateY) {
      if (_this.controller) {
        _this.controller.Translate(translateX, translateY);
      }
    };

    return _this;
  }

  return EditableImage;
}(React.Component);

exports.EditableImage = EditableImage;